import { Component, DOCUMENT, Inject, inject, Renderer2, signal } from '@angular/core';
import { Navbar } from '../navbar/navbar';
import { Footer } from '../footer/footer';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { Canonical } from '../../services/canonical';
import { Api } from '../../services/api';
import { ProductItem, Products as Prod } from '../../interface/products';
import { catchError, of, tap, timeout } from 'rxjs';
import { CurrencyPipe, TitleCasePipe } from '@angular/common';
import { TruncatePipe } from '../../pipes/truncate-pipe';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { RouterLink } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';

import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-products',
  imports: [
    Navbar,
    Footer,
    RouterLink,
    TitleCasePipe,
    TruncatePipe,
    CurrencyPipe,
    NgxSkeletonLoaderModule
  ],
  templateUrl: './products.html',
  styleUrl: './products.css',
})
export class Products {
  isLoading = signal(false);
  title = inject(Title);
  meta = inject(Meta);
  private http = inject(HttpClient);
  private api = inject(Api);
  private canonical = inject(Canonical);
  nutraceutics = signal<ProductItem[]>([]);
  pharmaceutics = signal<ProductItem[]>([]);

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    toSignal(this.http.get<any>(`${environment.apiUrl}/products`));
    this.setMetaTags();
    this.initialize();
  }
  
  private setMetaTags() : void {
    // const title = `Products - ${environment.appName}`;
    // const siteName = environment.appName;
    // const url = `${environment.basePath}/products`;
    // const description = 'All our products have undergone evaluation and are approved and license accredited by the Philippine Food and Drug Administration, ensuring they are safe and of high quality.';
    // this.title.setTitle(title);
    // this.canonical.setCanonicalUrl(url);

    // this.meta.addTags([
    //   {name: 'og:locale', content: 'en_US'},
    //   {meta: 'og:site_name', content: siteName},
    //   {name: 'og:title', content: title},
    //   {name: 'og:url', content: url},
    //   {name: 'og:description', content: description },
    //   {name: 'og:type', content: 'website'},
    //   {name: 'twitter:url', content: url},
    //   {name: 'twitter:title', content: title},
    //   {name: 'twitter:description', content: description}
    // ]);
  }

  private setSchema(obj?: string) : void {
    if(obj){
      const script = this.renderer.createElement('script');
      script.type = 'application/ld+json';
      script.text = obj!;
      this.renderer.appendChild(this.document.head, script);
    }
  }

  private initialize() : void {
    this.isLoading.set(true);

    this.api.getOptimizeProducts()
    .pipe(
      timeout(10000),
      catchError(() => of({
        canonical: null,
        title: null,
        meta: null,
        org: null
      }))
    ).subscribe(obj => {
      this.title.setTitle(obj?.title!);
      this.canonical.setCanonicalUrl(obj?.canonical!);
    });

    this.api.getProducts()
    .pipe(
      timeout(10000),
      catchError(() => of({
        nutraceutics: [],
        pharmaceutics: [],
        schema: null
      })),
      tap(() => this.isLoading.set(false))
    ).subscribe(obj => {
      this.nutraceutics.set(obj.nutraceutics);
      this.pharmaceutics.set(obj.pharmaceutics);
      this.setSchema(obj.schema!)
    });
  }
}
